export default function ContactMap() {
  return (
    <section className="py-16 bg-[#f4f2ef]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-8">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-2">Our Location</p>
            <h2 className="font-bold text-[#1a1a1a]" style={{ fontSize: 'clamp(1.25rem, 2.5vw, 1.625rem)' }}>
              台中設計總部
            </h2>
          </div>
          <a
            href="https://maps.google.com/?q=台中市北區中清路一段79號6樓-C"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-[#e2ddd8] bg-white text-[#5a5a5a] rounded-full text-sm font-medium hover:bg-[#f4f2ef] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-map-pin-line text-[#b8956a]"></i>
            Google Maps 導航
          </a>
        </div>
        <div className="w-full h-[380px] md:h-[440px] rounded-2xl overflow-hidden border border-[#e2ddd8]">
          <iframe
            src="https://maps.google.com/maps?q=%E5%8F%B0%E4%B8%AD%E5%B8%82%E5%8C%97%E5%8D%80%E4%B8%AD%E6%B8%85%E8%B7%AF%E4%B8%80%E6%AE%B579%E8%99%9F&t=&z=16&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="心旅商研台中設計總部地圖"
          ></iframe>
        </div>
        <p className="text-[#8a8a8a] text-sm mt-4 flex items-center gap-2">
          <i className="ri-map-pin-2-line text-[#b8956a]"></i>
          台中市北區中清路一段79號6樓-C
        </p>
      </div>
    </section>
  );
}
